import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Chip} from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import TextField from "@material-ui/core/TextField";
import "react-datepicker/dist/react-datepicker.css";
import {Controller, useForm} from "react-hook-form";
import ClipLoader from "react-spinners/ClipLoader";
import {bgItemTypes, jobContracts,} from "../../../db/models/const";
import {professionScopes} from "../../../db/datasets/professions";
import {closeDialog} from "../../../slices/dialog";
import {updateRmBgItem} from "../../../api/common";
import "../../CommonComponents.scss";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {selectSelectedRm} from "../../../slices/selected";
import {useTranslation} from "react-i18next";
import TextEditor from "../../../common/components/TextEditor/main";

export const EditRmJob = ({job}) => {
    const {t} = useTranslation();
    const {register, handleSubmit, control, errors} = useForm({
        defaultValues: {
            labels: job?.labels || [],
            // scope: professionScopes[job?.scopeId] || null,
            scopes: job?.scopeIds ? job.scopeIds.map(id => professionScopes[id]) :
                job?.scopeId != null ? [professionScopes[job.scopeId]] : [],
            contractId: job?.contractId || 0,
            months: job?.months != null ? job.months : null,
            optional: job?.importance === 2 ? true : false
        },
    });
    const [loading, setLoading] = useState(false);
    const rm = useSelector(selectSelectedRm);
    const docId = rm?.id;
    const dispatch = useDispatch();
    // const [scopeCount, setScopeCount] = useState(
    // 	job?.scopeIds ? job.scopeIds.length :
    // 		job?.scopeId != null ? 1 : 0
    // );
    const [description, setDescription] = useState(job?.description || "");

    const onSave = (data) => {
        const j = {
            ...job,
            // scopeId: data.scope.id,
            scopeIds: data.scopes.map(s => s.id),
            labels: data.labels,
            contractId: data.contractId,
            description,
            months: data.months != null ? Number(data.months) : null,
            importance: data.optional ? 2 : 1
        };

        console.log(j)

        setLoading(true);
        updateRmBgItem(docId, bgItemTypes.JOB, j, job == null)
            .then(() => {
                setLoading(false);
                dispatch(closeDialog());
            })
            .catch((error) => setLoading(false));
    };

    return (
        <div className="bg-dialog">
            <form onSubmit={handleSubmit(onSave)}>
                <div className="element">
                    <div className="label">{t("company_rm_editJob_scopes_label")}</div>
                    <Controller
                        render={({onChange, ...props}) => (
                            <Autocomplete
                                {...props}
                                multiple
                                filterSelectedOptions
                                options={professionScopes}
                                getOptionLabel={(option) => t(option.label)}
                                renderInput={(params) => <TextField {...params} />}
                                onChange={(e, x) => {
                                    onChange(x);
                                    // if (x) setScopeCount(x.length);
                                }}
                            />
                        )}
                        name={"scopes"}
                        onChange={(_, data) => data}
                        rules={{required: true, validate: (value) => value.length >= 1}}
                        control={control}
                    />
                    {errors.scopes && <p className="error">{t("company_rm_editJob_scopes_error")}</p>}
                </div>
                <div className="element">
                    <div className="label">{t("company_rm_editJob_contractType_label")}</div>
                    <Controller
                        render={({onChange, ...props}) => (
                            <Select
                                fullWidth
                                {...props}
                                onChange={(e) => onChange(e.target.value)}
                            >
                                {jobContracts.map((x) => (
                                    <MenuItem key={x.id} value={x.id}>
                                        {t(x.label)}
                                    </MenuItem>
                                ))}
                            </Select>
                        )}
                        name={"contractId"}
                        rules={{required: true}}
                        control={control}
                    />
                </div>
                <div className="element">
                    <div className="label">{t("company_rm_editJob_optional_label")}</div>
                    <div className="checkbox">
                        <input type="checkbox" name="optional" ref={register}></input>
                        <p>{t("company_rm_editJob_optional_text")}</p>
                    </div>
                </div>
                <div className="element">
                    <div className="label">{t("company_rm_editJob_duration_label")}</div>
                    <select name="months" ref={register}>
                        <option key={0} value={null}>Nessuna durata</option>
                        <option key={3} value={3}>3 months</option>
                        <option key={6} value={6}>6 months</option>
                        <option key={12} value={12}>1 year</option>
                    </select>
                </div>

                <div className="element">
                    <div className="label">{t("company_rm_editJob_jobTitles_label")}</div>
                    <Controller
                        render={({onChange, ...props}) => (
                            <Autocomplete
                                {...props}
                                multiple
                                freeSolo
                                renderTags={(value, getTagProps) =>
                                    value.map((option, index) => (
                                        <Chip label={option} {...getTagProps({index})} />
                                    ))
                                }
                                renderInput={(params) => (
                                    <TextField {...params} placeholder={t("company_rm_editJob_jobTitles_ph")}/>
                                )}
                                options={[]}
                                onChange={(e, x) => {
                                    onChange(x);
                                }}
                            />
                        )}
                        name={"labels"}
                        ref={register({required: true})}
                        control={control}
                    />
                </div>
                <div className="element">
                    <div className="label">{t("company_rm_editJob_descrizione_label")}</div>
                    <TextEditor
                        editorStyle={{minHeight: "150px"}}
                        placeholder={t("company_rm_editJob_descrizione_ph")}
                        defaultValue={description}
                        HTMLvalueOnChangeCB={setDescription}/>
                </div>
                {!loading && <input type="submit" value={t("company_rm_editJob_submit")}></input>}
                {loading && (
                    <div className="loader">
                        <ClipLoader size={20} color={"#7400b8"} loading={true}/>
                    </div>
                )}
            </form>
        </div>
    );
};